// Genera el curriculum en PDF (A4, formato CV) a partir de cv-data.js. jsPDF se carga bajo demanda desde cdnjs.
import cv from './cv-data'

const JSPDF_URL = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js'

function loadJsPdf() {
  if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF)
  return new Promise((resolve, reject) => {
    const el = document.createElement('script')
    el.src = JSPDF_URL
    el.onload = () => (window.jspdf && window.jspdf.jsPDF ? resolve(window.jspdf.jsPDF) : reject(new Error('jsPDF no disponible')))
    el.onerror = () => reject(new Error('No se pudo cargar jsPDF'))
    document.head.appendChild(el)
  })
}

const INK = [29, 33, 41]
const MUTED = [96, 104, 116]
const ACCENT = [18, 48, 107]

export async function downloadCv() {
  const JsPdf = await loadJsPdf()
  const doc = new JsPdf({ unit: 'mm', format: 'a4' })
  const W = 210
  const H = 297
  const M = 16
  const BOTTOM = 16
  const width = W - 2 * M
  let y = M

  const color = (c) => doc.setTextColor(c[0], c[1], c[2])
  const room = (h) => { if (y + h > H - BOTTOM) { doc.addPage(); y = M } }

  // Parrafo con ajuste de linea; pasa de pagina si hace falta.
  function para(str, opts = {}) {
    const { size = 9.5, bold = false, col = INK, indent = 0, gap = 1.2, bullet = false } = opts
    doc.setFont('helvetica', bold ? 'bold' : 'normal')
    doc.setFontSize(size)
    color(col)
    const lh = size * 0.46
    const x = M + indent + (bullet ? 4 : 0)
    const lines = doc.splitTextToSize(String(str), width - indent - (bullet ? 4 : 0))
    lines.forEach((line, i) => {
      room(lh)
      if (bullet && i === 0) {
        doc.setFillColor(col[0], col[1], col[2])
        doc.circle(M + indent + 1.2, y - lh * 0.32, 0.45, 'F')
      }
      doc.text(line, x, y)
      y += lh
    })
    y += gap
  }

  function section(title) {
    room(14)
    y += 3
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(11)
    color(ACCENT)
    doc.text(title.toUpperCase(), M, y)
    doc.setDrawColor(ACCENT[0], ACCENT[1], ACCENT[2])
    doc.setLineWidth(0.5)
    doc.line(M, y + 1.6, W - M, y + 1.6)
    y += 6.5
  }

  // Cabecera
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(22)
  color(INK)
  doc.text(cv.name, M, y + 6)
  y += 12
  doc.setFontSize(12)
  color(ACCENT)
  doc.text(cv.headline, M, y)
  y += 5.5
  para(cv.tagline, { size: 9.5, col: MUTED, gap: 1 })
  para(cv.contact.join('   |   '), { size: 8.8, col: MUTED, gap: 2 })

  section('Profile')
  cv.summary.forEach((p) => para(p, { gap: 1.6 }))

  section('Skills')
  cv.skills.forEach(([k, v]) => {
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(9.2)
    const label = k + ':  '
    const lw = doc.getTextWidth(label)
    doc.setFont('helvetica', 'normal')
    const lines = doc.splitTextToSize(v, width - lw)
    room(lines.length * 4.2)
    doc.setFont('helvetica', 'bold')
    color(INK)
    doc.text(label, M, y)
    doc.setFont('helvetica', 'normal')
    color(MUTED)
    lines.forEach((line, i) => doc.text(line, M + lw, y + i * 4.2))
    y += lines.length * 4.2 + 1
  })

  section('Soft skills')
  cv.softSkills.forEach((s) => para(s, { bullet: true, gap: 0.6 }))

  section('Experience')
  cv.experience.forEach((e) => {
    room(18)
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(10.2)
    color(INK)
    doc.text(e.company + (e.place ? '  -  ' + e.place : ''), M, y)
    if (e.dates) {
      doc.setFont('helvetica', 'normal')
      doc.setFontSize(9)
      color(MUTED)
      doc.text(e.dates, W - M, y, { align: 'right' })
    }
    y += 4.6
    para(e.role, { bold: true, col: ACCENT, size: 9.6, gap: 0.8 })
    if (e.text) para(e.text, { gap: 0.8 })
    ;(e.bullets || []).forEach((b) => para(b, { bullet: true, gap: 0.4 }))
    if (e.tech) para('Technologies: ' + e.tech, { size: 8.8, col: MUTED, gap: 0.8 })
    y += 2
  })

  section('Education & training')
  cv.education.forEach(([t, d]) => {
    room(5)
    doc.setFont('helvetica', 'normal')
    doc.setFontSize(9.4)
    color(INK)
    const lines = doc.splitTextToSize(t, width - 28)
    doc.text(lines, M, y)
    doc.setFontSize(9)
    color(MUTED)
    doc.text(d, W - M, y, { align: 'right' })
    y += lines.length * 4.3 + 1.2
  })

  section('Languages')
  para(cv.languages.map(([l, v]) => l + ': ' + v).join('   |   '), { gap: 1 })

  section('Honours & awards')
  para(cv.awards.join('   |   '), { gap: 1 })

  // Pie con numero de pagina
  const pages = doc.getNumberOfPages()
  for (let i = 1; i <= pages; i++) {
    doc.setPage(i)
    doc.setFont('helvetica', 'normal')
    doc.setFontSize(8)
    color(MUTED)
    doc.text(cv.name + '  -  ' + i + '/' + pages, W / 2, H - 8, { align: 'center' })
  }
  doc.save('Nuno-Valencia-CV.pdf')
}
